/* ==========================================================================
   Cart drawer — opens on add-to-cart, Frequently Bought Together via Swiper.
   Figma node 72-3459.
   ========================================================================== */
(function () {
  'use strict';

  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  function url(path) { return (ROOT + path).replace(/\/{2,}/g, '/'); }

  function getDrawer() { return document.querySelector('cart-drawer'); }

  /* ------------------------------------------------------------------ */
  /* <cart-drawer>                                                       */
  /* ------------------------------------------------------------------ */
  if (!customElements.get('cart-drawer')) {
    customElements.define('cart-drawer', class CartDrawer extends HTMLElement {
      connectedCallback() {
        this.lastAddedProductId = this.lastAddedProductId || '';
        this.addEventListener('click', this.onClick.bind(this));
      }

      onClick(e) {
        if (e.target.closest('[data-cart-overlay]') || e.target.closest('[data-cart-close]')) {
          e.preventDefault();
          this.close();
          return;
        }
        var plus = e.target.closest('[data-qty-plus]');
        var minus = e.target.closest('[data-qty-minus]');
        var remove = e.target.closest('[data-cart-remove]');
        if (plus || minus || remove) {
          e.preventDefault();
          e.stopPropagation();
          var itemEl = e.target.closest('[data-cart-item]');
          if (!itemEl) return;
          var line = itemEl.getAttribute('data-line');
          var current = parseInt(itemEl.querySelector('[data-qty-value]').textContent, 10) || 1;
          var qty = current;
          if (plus) qty = current + 1;
          if (minus) qty = current - 1;
          if (remove) qty = 0;
          itemEl.classList.add('is-loading');
          this.changeLine(line, qty);
        }
      }

      open() {
        this.classList.add('is-open');
        document.body.classList.add('cart-drawer-open');
        this.setAttribute('aria-hidden', 'false');
      }

      close() {
        this.classList.remove('is-open');
        document.body.classList.remove('cart-drawer-open');
        this.setAttribute('aria-hidden', 'true');
      }

      /* Replace the inner markup from a rendered cart-drawer section */
      updateFromSectionHTML(html) {
        if (!html) { return this.refreshFromCart(); }
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var newInner = doc.querySelector('[data-cart-inner]');
        var curInner = this.querySelector('[data-cart-inner]');
        if (newInner && curInner) {
          curInner.innerHTML = newInner.innerHTML;
        }
        var count = doc.querySelector('cart-drawer');
        if (count) this.setAttribute('data-cart-count', count.getAttribute('data-cart-count'));
        this.loadFBT();
        this.updateBubble();
      }

      /* Fallback: re-fetch the section if a mutation didn't return sections */
      refreshFromCart() {
        var self = this;
        fetch(url('?sections=cart-drawer'))
          .then(function (r) { return r.json(); })
          .then(function (data) { self.updateFromSectionHTML(data['cart-drawer']); })
          .catch(function () {});
      }

      changeLine(line, quantity) {
        var self = this;
        return fetch(url('cart/change.js'), {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ line: Number(line), quantity: quantity, sections: 'cart-drawer', sections_url: location.pathname })
        })
          .then(function (r) { return r.json(); })
          .then(function (data) {
            if (data.status) { console.error('[cart-drawer] change error', data); return self.refreshFromCart(); }
            self.updateFromSectionHTML(data.sections && data.sections['cart-drawer']);
          })
          .catch(function (err) { console.error('[cart-drawer] change failed', err); self.refreshFromCart(); });
      }

      loadFBT() {
        var fbt = this.querySelector('fbt-carousel');
        if (!fbt) return;
        var pid = this.lastAddedProductId || fbt.getAttribute('data-product-id');
        if (typeof fbt.load === 'function') fbt.load(pid);
      }

      updateBubble() {
        var count = this.getAttribute('data-cart-count');
        document.querySelectorAll('[data-cart-count]').forEach(function (el) {
          if (el.tagName.toLowerCase() === 'cart-drawer') return;
          el.textContent = count;
        });
      }
    });
  }

  /* ------------------------------------------------------------------ */
  /* <fbt-carousel>                                                      */
  /* ------------------------------------------------------------------ */
  if (!customElements.get('fbt-carousel')) {
    customElements.define('fbt-carousel', class FbtCarousel extends HTMLElement {
      load(productId) {
        var section = this.closest('.cart-drawer__fbt');
        if (!productId) { this.hide(section); return; }
        var limit = this.getAttribute('data-limit') || 8;
        var intent = this.getAttribute('data-intent') || 'related';
        var self = this;
        var endpoint = url('recommendations/products') +
          '?section_id=cart-fbt&limit=' + encodeURIComponent(limit) +
          '&intent=' + encodeURIComponent(intent) +
          '&product_id=' + encodeURIComponent(productId);

        fetch(endpoint)
          .then(function (r) { return r.text(); })
          .then(function (text) {
            var doc = new DOMParser().parseFromString(text, 'text/html');
            var slides = doc.querySelector('[data-fbt-slides]');
            var wrapper = self.querySelector('[data-fbt-wrapper]');
            if (!slides || !wrapper || slides.children.length === 0) { self.hide(section); return; }
            wrapper.innerHTML = slides.innerHTML;
            self.show(section);
            self.initSwiper();
          })
          .catch(function (err) { console.error('[fbt-carousel] load failed', err); self.hide(section); });
      }

      initSwiper() {
        if (typeof Swiper === 'undefined') return;
        if (this.swiper) { this.swiper.destroy(true, true); this.swiper = null; }
        this.swiper = new Swiper(this.querySelector('.cart-fbt-swiper'), {
          slidesPerView: 'auto',
          spaceBetween: 32,
          freeMode: true,
          scrollbar: { el: this.querySelector('[data-fbt-scrollbar]'), draggable: true },
          grabCursor: true
        });
      }

      hide(section) { if (section) section.hidden = true; }
      show(section) { if (section) section.hidden = false; }

      disconnectedCallback() { if (this.swiper) { this.swiper.destroy(true, true); this.swiper = null; } }
    });
  }

  /* ------------------------------------------------------------------ */
  /* Add-to-cart interception (capture phase, site-wide)                 */
  /* ------------------------------------------------------------------ */
  function addFromForm(form) {
    var drawer = getDrawer();
    if (!drawer) { form.submit(); return; }
    var btn = form.querySelector('[type="submit"], [name="add"]');
    if (btn) btn.classList.add('loading');

    var formData = new FormData(form);
    formData.append('sections', 'cart-drawer');
    formData.append('sections_url', location.pathname);

    fetch(url('cart/add.js'), {
      method: 'POST',
      headers: { 'X-Requested-With': 'XMLHttpRequest', 'Accept': 'application/javascript' },
      body: formData
    })
      .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, data: d }; }); })
      .then(function (res) {
        if (!res.ok) { throw res.data; }
        var data = res.data;
        var pid = data.product_id || (data.items && data.items[0] && data.items[0].product_id);
        if (pid) drawer.lastAddedProductId = String(pid);
        var html = data.sections && data.sections['cart-drawer'];
        drawer.updateFromSectionHTML(html);
        drawer.open();
        document.dispatchEvent(new CustomEvent('cart-drawer:added', { detail: { productId: pid, item: data } }));
      })
      .catch(function (err) {
        console.error('[cart-drawer] add failed', err);
        // `form` lets listeners (e.g. the PDP buy button) tell whether this
        // particular error belongs to them when multiple add-to-cart forms
        // exist on the same page.
        document.dispatchEvent(new CustomEvent('cart-drawer:error', { detail: { error: err, form: form } }));
      })
      .finally(function () { if (btn) btn.classList.remove('loading'); });
  }

  function isAddToCartForm(form) {
    if (!form) return false;
    if (form.hasAttribute('data-no-drawer')) return false;
    if (form.hasAttribute('data-fbt-add')) return true;
    var action = form.getAttribute('action') || '';
    return /\/cart\/add\b/.test(action);
  }

  /* Primary interception: the theme handles the ATC *click* (jQuery) and
     redirects, so the native submit never fires. Catch the click first. */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest(
      'button[type="submit"], input[type="submit"], [name="add"], [data-btn-addToCart], [data-fbt-add] button'
    );
    if (!btn) return;
    var form = btn.closest('form');
    if (!isAddToCartForm(form)) return;
    if (form.checkValidity && !form.checkValidity()) return; // let native validation show
    e.preventDefault();
    e.stopImmediatePropagation();
    addFromForm(form);
  }, true);

  /* Backup: catch keyboard/native submits that weren't preceded by a click. */
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!(form instanceof HTMLFormElement)) return;
    if (!isAddToCartForm(form)) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    addFromForm(form);
  }, true);

  /* Open the drawer from the header cart icon instead of navigating to /cart */
  document.addEventListener('click', function (e) {
    var toggle = e.target.closest('[data-cart-drawer-toggle], .header__icon--cart, .cart-icon-bubble');
    if (!toggle) return;
    var drawer = getDrawer();
    if (!drawer) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    drawer.open();
    drawer.loadFBT();
  }, true);

  window.openCartDrawer = function () { var d = getDrawer(); if (d) d.open(); };

  /* Close on Escape */
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') { var d = getDrawer(); if (d && d.classList.contains('is-open')) d.close(); }
  });
})();
